import React, { useState, useImperativeHandle, forwardRef } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PDFViewer from "./PDFViewer";

const DietChartPreviewer = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");

  useImperativeHandle(ref, () => ({
    openPreview: (pdfUrl) => {
      setUrl(pdfUrl);
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setUrl("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xl"
      PaperProps={{
        style: { height: "90vh", overflow: "hidden" },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
          zIndex: 10,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent
        sx={{ p: 0, height: "100%", overflow: "hidden" }}
        onContextMenu={(e) => e.preventDefault()}
      >
        {url && <PDFViewer url={url} />}
      </DialogContent>
    </Dialog>
  );
});

export default DietChartPreviewer;
